import { combineReducers } from "redux";

import customFields, { CustomFieldsActions } from "./component/CustomFields/store";
import fileTags, { FileTagsActions } from "./component/FileTags/store";
import formLayouts, { FormLayoutsActions } from "./component/FormLayouts/store";
import imports, { ImportActions } from "./component/Imports/store";
import manageFields, { ManageFieldsActions } from "./component/ManageFields/store";
import mergeDuplicates, { MergeDuplicatesActions } from "./component/MergeDuplicates/store";
import organizationDetails, {
  OrganizationDetailsActions,
} from "./component/OrganizationDetails/store";
import restorableRecords, { RestorableRecordsActions } from "./component/RestorableRecords/store";
import sandbox, { SandboxActions } from "./component/Sandbox/store";
import { SessionsActions } from "./component/Sessions/store";

const settingsReducer = combineReducers({
  customFields,
  fileTags,
  formLayouts,
  imports,
  manageFields,
  mergeDuplicates,
  organizationDetails,
  restorableRecords,
  sandbox,
});

export type SettingsActions =
  | CustomFieldsActions
  | FileTagsActions
  | FormLayoutsActions
  | ImportActions
  | ManageFieldsActions
  | MergeDuplicatesActions
  | OrganizationDetailsActions
  | RestorableRecordsActions
  | SandboxActions
  | SessionsActions;

export default settingsReducer;
